/**
 * @generated SignedSource<<16e2f0cca152a5acdb413c97fdffc48e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuth_viewer$data = {
  readonly userTokenCanCheckout?: boolean | null;
  readonly " $fragmentType": "useAuth_viewer";
};
export type useAuth_viewer$key = {
  readonly " $data"?: useAuth_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuth_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "buyerId"
    },
    {
      "kind": "RootArgument",
      "name": "hasBuyerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuth_viewer",
  "selections": [
    {
      "condition": "hasBuyerId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "buyerId"
            }
          ],
          "kind": "ScalarField",
          "name": "userTokenCanCheckout",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "be8b3d23e3d4d2d8788e455d8ef77e35";

export default node;
